export enum FeatureFlag {
  SPOTTARIF = 'rechnungen-show_spot_tariff',
  SUBUSER = 'subusers-enable_registration',
  UMMELDUNG = 'zaehlpunkte-enable_ummeldung',
  CONSUMPTION = 'zaehlpunkt_details-enable_verbrauch_export',
  METERPOINTS_EXPORT = 'zaehlpunkte-enable_export',
}

export interface FeatureFlagResponse {
  enabled: boolean;
}
